import React from 'react';
import ExploreCard from './ExploreCard';

export default function ExploreGrid({ pages }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {pages.map((page) => (
        <ExploreCard key={page.username} page={page} />
      ))}
    </div>
  );
}